import { ResolveWalletResponse } from "../../types/wallet";

export const resolveWalletModel = (
  response: ResolveWalletResponse
): ResolveWalletResponse => response;
